import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ConfigCtx = createContext({
  currency: "nzd",
  currency_symbol: "$",
  shipping_flat_nz: 35,
  local_delivery_fee_nz: 10,
  contact_email: "shootagun@hotmail.com",
  pickup_location: "Invercargill",
});

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState({
    currency: "nzd",
    currency_symbol: "$",
    shipping_flat_nz: 35,
    local_delivery_fee_nz: 10,
    contact_email: "shootagun@hotmail.com",
    pickup_location: "Invercargill",
  });

  useEffect(() => {
    api.get("/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  return <ConfigCtx.Provider value={config}>{children}</ConfigCtx.Provider>;
}

export const useConfig = () => useContext(ConfigCtx);
